import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _pick from "lodash/pick";
import _cloneDeep from "lodash/cloneDeep";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
/* eslint-disable no-param-reassign */
import produce, { current } from 'immer';
import initialState from '../initialState';

// These filterSettings describe the sample itself rather than the filter, so a sample
// keeps its own when the settings of another one (e.g. from a different kit) are copied
var sampleIntrinsicSettings = ['kit', 'ffpe'];
var copyFilterSettingsToAllSamples = produce(function (draft, action) {
  var _action$payload = action.payload,
    step = _action$payload.step,
    sourceSampleId = _action$payload.sourceSampleId,
    sampleIds = _action$payload.sampleIds;
  var sourceSettings = current(draft.processing[step][sourceSampleId]);
  var targetSamples = sampleIds.filter(function (sampleId) {
    return sampleId !== sourceSampleId;
  });
  targetSamples.forEach(function (targetSampleId) {
    var targetSampleStepConfig = draft.processing[step][targetSampleId];
    targetSampleStepConfig.auto = sourceSettings.auto;
    if (sourceSettings.auto) {
      targetSampleStepConfig.filterSettings = current(targetSampleStepConfig.defaultFilterSettings);
      return;
    }
    targetSampleStepConfig.filterSettings = _objectSpread(_objectSpread({}, _cloneDeep(sourceSettings.filterSettings)), _pick(targetSampleStepConfig.filterSettings, sampleIntrinsicSettings));
  });
}, initialState);
export default copyFilterSettingsToAllSamples;